type StorageKey =
  | '2faData'
  | 'resetPwd'
  | 'confirmEmailData'
  | 'enterEmailData'
  | 'confirmPasswordData'
  | 'currentUserForInvite'
  | 'userInfo';

class MemoryStorageManager {
  storage: Record<string, any>;

  constructor() {
    this.storage = {};
  }

  getAll = (): Record<string, any> => {
    return this.storage;
  };

  get = (key: StorageKey) => {
    return this.storage[key];
  };

  set = (value: Record<string, any>): void => {
    this.storage = {
      ...this.storage,
      ...value,
    };
  };

  remove = (key: StorageKey): void => {
    delete this.storage[key];
  };

  removeAll = () => {
    this.storage = {};
  };
}

export const memoryStorageManager = new MemoryStorageManager();
